import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import store, { actions } from "@/store";
import { userManager } from "@/utils/identity";
import uiComponents from "@/components/ui";
import icons from "@/assets/icons";
import i18n from "@/i18n";
import appMixins from "@/mixins";
import appInsights, { trackEvent, trackException } from "@/appInsights";
import { startInputWatchdog } from "@/utils/inputWatchdog";

Vue.use(uiComponents);
Vue.use(icons);
Vue.use(appMixins);
Vue.use(appInsights, {
  router,
  store,
  config: {
    instrumentationKey: process.env.VUE_APP_INSTRUMENTATION_KEY
  }
});

// Silent: it renders nothing and changes nothing on the page. It watches for
// operators losing all mouse input while the page keeps running (see
// debug/README.md) and reports which of the two possible causes it was, since
// that is the one thing static analysis could not settle. Started after
// Vue.use(appInsights) so the real trackEvent is in place, and wrapped because
// appInsights swaps the export out on install.
startInputWatchdog({ trackEvent: event => trackEvent(event) });

Vue.config.productionTip = false;

if (process.env.NODE_ENV !== "production") {
  // eslint-disable-line no-console
  console.warn(process.env.NODE_ENV);
}

(async function () {
  try {
    const user = await userManager.getUser();
    store.dispatch(actions.identityInit, user);
  } catch (error) {
    trackException({
      exception: error,
      properties: { source: "main/bootstrap" }
    });
    store.dispatch(actions.identityError, error);
  }

  new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount("#app");
})();
